(function(){
  'use strict';
  if(window.__mxpPromoGiftV42)return;
  window.__mxpPromoGiftV42=true;

  var TXN='mxpPromoGiftTxnV42';
  var CONF='mxpPromoGiftConfirmedV42';
  var FLASH='mxpPromoGiftFlashV42';
  var MAX_AGE=15*60*1000;
  var SINGLE_GIFT_CODE='MXP1GIFT9ZK7';
  var SINGLE_GIFT_IDS=Object.create(null);
  var VALID_GIFT_CODES=["Mhoma","Abd","Actif","Aïcha","Banne","Benjamin","Bleji","Charel","CHAZAR","Christ","Doriane","Eden","Eldini","ETIENNE","Eutyche","Gomez","HALI","Hazam","IBR","Ibrahima","Igo","Issa","IVANN","Jaune","Joe","JR","Juju","Latch","Leancia","Lilou","Litim","LMN","Lulu","Mamadou","Mathis","MOUSTAFA","NMG","Preston","Richie","Ross","Salim","SAMI","Santos","Suny","Tayna","Tidiane","Ugo","Wil","Wilfried","Winner","Young","Alex","ANGELO","Antoine","Aris","Audi","Balla","Bilou","Bleu","Blue","Bouna","Bricelh","Christian","Daouda","Doul","Emery","FAD","Firmin","French","Giovanni","Halim","Hiskia","Jack","Jay","JHAA","Josué","KENDRY","Kervin","Kev","Khaled","KILYAN","Loic","LOUIS","Louise","Ludo","Malick","Namory","Noir","Osazee","Paul","Pedro","Rania","Ryan","Said","Sekou","Sénégal","Tarek","Vert","WALLEN","XPH","YANAËL","Aboubacar","Ad","Aline","Ben","Bibs","Boom","Cœur","Djamil","Doumbe88","Ederson","Fares","Fayad","Fofana","Gael","George","Hakim","HATUB","ISAAC","Ismail","Ivory","JAEL","JAWAN","Jboss75","Jeff","Jlx","Jordane","KHABANE","Kikou99","Krys","Lelax40","Lumière","Malek","Maman58","Marlone","Maxence","MIKAHEL","MXMO","NOUNOUCHE","Oiseau","OMAX","Ouattara","Papa","Souley","Vany","VICTELSON","VINCENZO","Warren","William","YOH","Zajei","Abu","Affif","ALLAH","ALN","ARONA","Ayrton","Bonus","Chaleur","Diama","Doudou","Eldin","Elma","Fatima","FÉFÉ","Fleur","Gaby","Gorby","IBOUSOW","Jaja","Julia","KDN","KESKOO","Khephren","Kinian","KML","Ledson","LND","LSF","Luss","MAERA","Manu","MDB","Missa","MLK","Mohammad","Monsieur","Naceur","Ochet","Pistache","Promo","Raph","Rose","Saad","Smiley","Soleil","Verane","Yanis","Yanyan","YOUMNA","Youssef","Alana","Alexander","Aminata","Ange","ASSANE","Ben70","BENDERO","Binks40","Braskoo","Cindy","Dan","Djeba","Elder","Foot","Gabin","Gwen","GYLL","Homa","Kasongo","Kengy","Lerat75","Lili","Lindsay","Loann","Magalie","Maiga","Maligo","Many","Mazz","Mini","Missak70","Mnk","Mohamed","Nathalie","NAYANN","Oumar","PRESKO","ROMANN","Rouge","Samir","smb","Sophie","Tzi85","Vanille","YS"];
  VALID_GIFT_CODES.push("etoile85", "lisio95", "terry29", "absetou", "Xdeal");
  var VALID_GIFT_CODE_MAP=Object.create(null);
  VALID_GIFT_CODES.forEach(function(code){VALID_GIFT_CODE_MAP[String(code).toLowerCase()]=1});
  function isValidGiftCode(code){return !!VALID_GIFT_CODE_MAP[String(code||'').trim().toLowerCase()]}

  ['mxpPromoGiftTxnV41','mxpPromoGiftConfirmedV41','mxpPromoGiftFlashV41','mxpPromoGiftTxnV4','mxpPromoGiftConfirmedV4','mxpPromoGiftFlashV4','mxpPromoGiftTxnV3','mxpPromoGiftConfirmedV3','mxpPromoGiftFlashV3','mxpPromoGiftTxnV2','mxpPromoGiftConfirmedV2','mxpPromoGiftFlashV2','mxpPromoGiftPendingCode','mxpPromoGiftActiveCode','mxpPromoGiftFlash'].forEach(function(k){
    try{sessionStorage.removeItem(k)}catch(e){}
  });

  var V={
    charger2a:58758755385676,
    lightning:58758754763084,
    usbAC:58969799426380,
    macL:59005547315532,
    macT:59005547741516,
    macUsbC:59005548003660,
    pin30:59005664854348,
    microUsb:59005665116492
  };
  [V.macL,V.macT,V.macUsbC,V.pin30,V.microUsb].forEach(function(id){SINGLE_GIFT_IDS[String(id)]=1});

  function base(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/'}
  function norm(v){
    var s=String(v||'').toLowerCase();
    try{s=s.normalize('NFD').replace(/[\u0300-\u036f]/g,'')}catch(e){}
    return s.replace(/\s+/g,' ').trim();
  }
  function props(item){return item&&item.properties&&typeof item.properties==='object'?item.properties:{}}
  function isGift(item){return String(props(item)._MAXPROMO_Cadeau||'')==='1'}
  function isService(item){
    var s=norm([item&&item.product_title,item&&item.title,item&&item.handle,item&&item.product_type].filter(Boolean).join(' '));
    var p=props(item);
    if(/reparat|repair-checkout|reprise|trade.?in|diagnostic/.test(s))return true;
    return Object.keys(p).some(function(k){
      var x=norm(k);
      return /reparation|panne|reprise|diagnostic/.test(x);
    });
  }
  function isAccessoryProduct(item){
    var type=norm(item&&item.product_type);
    var s=norm([item&&item.product_title,item&&item.title,item&&item.handle,type].filter(Boolean).join(' '));
    if(/accessoire|accessory/.test(type))return true;
    return /chargeur|charger|cable|adaptateur|adapter|prise secteur/.test(s);
  }
  function modelYear(s){var m=norm(s).match(/\b(20\d{2}|19\d{2})\b/);return m?Number(m[1]):0}
  function generationOf(s){var m=norm(s).match(/(?:-|\s)(\d+)(?:e|re)?\s+generation\b/);return m?Number(m[1]):0}
  function seriesNumber(s,label){
    var x=norm(s),re=new RegExp(label.replace(/\s+/g,'\\s*')+'\\s*(\\d{1,2})\\b');
    var m=x.match(re);return m?Number(m[1]):0;
  }

  function macGiftFor(source){
    var s=norm(source),year=modelYear(s);
    var air=s.indexOf('macbook air')!==-1,pro=s.indexOf('macbook pro')!==-1;
    if(/\bm[1-9]\b|thunderbolt\s*3|usb\s*-?\s*c/.test(s))return V.macUsbC;
    if(air){if(year>=2018)return V.macUsbC;if(year>=2012)return V.macT;return V.macL}
    if(pro){if(year>=2016)return V.macUsbC;if(year>=2012)return V.macT;return V.macL}
    if(year>=2015)return V.macUsbC;
    if(year>=2012)return V.macT;
    if(year&&year<=2011)return V.macL;
    return V.macUsbC;
  }

  function iphoneGiftFor(source){
    var s=norm(source);
    if(/iphone\s*(?:2g|3g|3gs|4|4s)\b/.test(s)||s.indexOf('original iphone')!==-1)return V.pin30;
    if(s.indexOf('iphone air')!==-1)return V.usbAC;
    var m=s.match(/iphone\s*(\d{1,2})\b/);
    if(m){var model=Number(m[1]);if(model<=4)return V.pin30;if(model>=15)return V.usbAC;return V.lightning}
    if(s.indexOf('iphone se')!==-1||/iphone\s*(?:x|xs|xr)\b/.test(s))return V.lightning;
    return V.lightning;
  }

  function ipadGiftFor(source){
    var s=norm(source),gen=generationOf(s),year=modelYear(s),n;
    if(s.indexOf('ipad mini')!==-1){
      n=seriesNumber(s,'ipad mini');
      if(n)return n>=6?V.usbAC:V.lightning;
      return gen>=6?V.usbAC:V.lightning;
    }
    if(s.indexOf('ipad air')!==-1){
      n=seriesNumber(s,'ipad air');
      if(n)return n>=4?V.usbAC:V.lightning;
      return gen>=4?V.usbAC:V.lightning;
    }
    if(s.indexOf('ipad pro')!==-1){
      if(/ipad pro\s*11\b/.test(s))return V.usbAC;
      if(/12[.,]9/.test(s)&&gen>=3)return V.usbAC;
      if(year>=2018)return V.usbAC;
      return V.lightning;
    }
    if(gen){if(gen<=3)return V.pin30;if(gen>=10)return V.usbAC;return V.lightning}
    n=seriesNumber(s,'ipad');
    if(n&&n<=3)return V.pin30;
    if(n&&n>=10)return V.usbAC;
    if(n&&n>=4&&n<=9)return V.lightning;
    if(year&&year<=2011)return V.pin30;
    if(year>=2022)return V.usbAC;
    return V.lightning;
  }

  function samsungTabGiftFor(source){
    var s=norm(source),year=modelYear(s),m=s.match(/galaxy tab\s*s(\d+)/);
    if(m)return Number(m[1])>=3?V.usbAC:V.microUsb;
    if(/galaxy tab\s*4\b/.test(s)||/tab active\s*2\b/.test(s))return V.microUsb;
    if(/tab a7\b|tab a8\b|tab a9\b|tab active\s*[345]\b/.test(s))return V.usbAC;
    if(year&&year<=2017)return V.microUsb;
    return V.usbAC;
  }

  function samsungPhoneGiftFor(source){
    var s=norm(source),m=s.match(/galaxy\s*s(\d+)/);
    if(m)return Number(m[1])<=7?V.microUsb:V.usbAC;
    m=s.match(/galaxy\s*note\s*(\d+)/);
    if(m)return Number(m[1])<=5?V.microUsb:V.usbAC;
    if(/galaxy\s*j\d|galaxy\s+j\b/.test(s))return V.microUsb;
    var year=modelYear(s);
    if(year&&year<=2016)return V.microUsb;
    return V.usbAC;
  }

  function otherAndroidGiftFor(source){var y=modelYear(source);return y&&y<=2017?V.microUsb:V.usbAC}
  function mobileGiftSet(connector){return (connector===V.pin30||connector===V.microUsb)?[connector]:[V.charger2a,connector]}

  function giftIdsFor(item){
    var s=norm([item.product_title,item.title,item.handle,item.product_type,item.vendor,item.variant_title].filter(Boolean).join(' '));
    if(s.indexOf('macbook')!==-1)return [macGiftFor(s)];
    if(s.indexOf('ipad')!==-1)return mobileGiftSet(ipadGiftFor(s));
    if((s.indexOf('samsung')!==-1&&s.indexOf('tab')!==-1)||s.indexOf('galaxy tab')!==-1)return mobileGiftSet(samsungTabGiftFor(s));
    if(s.indexOf('iphone')!==-1)return mobileGiftSet(iphoneGiftFor(s));
    if(s.indexOf('samsung')!==-1||s.indexOf('galaxy')!==-1)return mobileGiftSet(samsungPhoneGiftFor(s));
    if(/android|xiaomi|redmi|oppo|honor|huawei|motorola|nokia|oneplus|pixel/.test(s))return mobileGiftSet(otherAndroidGiftFor(s));
    return [];
  }

  function planFor(cart){
    var counts={};
    (cart&&Array.isArray(cart.items)?cart.items:[]).forEach(function(item){
      if(isGift(item)||isService(item)||isAccessoryProduct(item))return;
      var qty=Math.max(1,Number(item.quantity)||1);
      giftIdsFor(item).forEach(function(id){
        var k=String(id);counts[k]=(counts[k]||0)+qty;
      });
    });
    return counts;
  }

  function samePlan(a,b){
    a=a||{};b=b||{};
    var ka=Object.keys(a).sort(),kb=Object.keys(b).sort();
    if(ka.length!==kb.length)return false;
    for(var i=0;i<ka.length;i++){
      if(ka[i]!==kb[i]||Number(a[ka[i]])!==Number(b[kb[i]]))return false;
    }
    return true;
  }

  function planNeedsSingleGift(plan){
    return Object.keys(plan||{}).some(function(id){
      return SINGLE_GIFT_IDS[String(id)]&&Number(plan[id]||0)>0;
    });
  }

  function persistTxn(txn){
    try{sessionStorage.setItem(TXN,JSON.stringify(txn))}catch(e){}
  }

  function fetchCart(){
    return fetch(base()+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('cart');return r.json()});
  }
  function changeLine(key,qty){
    return fetch(base()+'cart/change.js',{
      method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({id:key,quantity:Math.max(0,Number(qty)||0)})
    }).then(function(r){if(!r.ok)return r.text().then(function(t){throw new Error(t||'change')});return r.json()});
  }
  function addGift(id,qty,code){
    return fetch(base()+'cart/add.js',{
      method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{
        id:Number(id),
        quantity:Math.max(1,Number(qty)||1),
        properties:{'_MAXPROMO_Cadeau':'1','_MAXPROMO_Code':String(code||''),'_MAXPROMO_Offre':'Accessoires offerts'}
      }]})
    }).then(function(r){if(!r.ok)return r.text().then(function(t){throw new Error(t||'add')});return r.json()});
  }
  function removeGifts(cart){
    var gifts=(cart&&Array.isArray(cart.items)?cart.items:[]).filter(isGift),chain=Promise.resolve();
    gifts.forEach(function(item){chain=chain.then(function(){return changeLine(item.key,0)})});
    return chain;
  }
  function addPlan(plan,code){
    var ids=Object.keys(plan||{}),chain=Promise.resolve();
    ids.forEach(function(id){chain=chain.then(function(){return addGift(id,plan[id],code)})});
    return chain;
  }

  var reconcileGiftPromise=null;
  function reconcilePromoGifts(cart){
    if(reconcileGiftPromise)return reconcileGiftPromise;

    reconcileGiftPromise=Promise.resolve(cart||fetchCart()).then(function(current){
      var desired=planFor(current);
      var gifts=(current&&Array.isArray(current.items)?current.items:[]).filter(isGift);
      if(!gifts.length)return current;

      var kept=Object.create(null);
      var chain=Promise.resolve(current);

      gifts.forEach(function(item){
        chain=chain.then(function(latest){
          var id=String(item.variant_id||item.id||'');
          var allowed=Math.max(0,Number(desired[id]||0));
          var already=Math.max(0,Number(kept[id]||0));
          var remaining=Math.max(0,allowed-already);
          var currentQty=Math.max(0,Number(item.quantity)||0);
          var target=Math.min(currentQty,remaining);
          kept[id]=already+target;

          if(target===currentQty)return latest;
          return changeLine(item.key,target);
        });
      });

      return chain.then(function(latest){
        var finalCart=latest||current;
        var finalPlan=planFor(finalCart);
        var conf=null;
        try{conf=JSON.parse(sessionStorage.getItem(CONF)||'null')}catch(e){}

        if(conf&&conf.code){
          if(Object.keys(finalPlan).length&&matchesPlan(finalCart,finalPlan)){
            try{
              sessionStorage.setItem(CONF,JSON.stringify({
                code:conf.code,
                plan:finalPlan,
                ts:Date.now()
              }));
            }catch(e){}
          }else if(!Object.keys(finalPlan).length){
            clearConfirmed();
          }else if(!giftPlanPresent(finalCart,finalPlan)){
            clearConfirmed();
          }
        }
        return finalCart;
      });
    }).finally(function(){
      reconcileGiftPromise=null;
    });

    return reconcileGiftPromise;
  }

  function isFree(item){
    if(!item)return false;
    var original=Number(item.original_line_price||item.line_price||0);
    var finalLine=Number(item.final_line_price);
    if(Number.isFinite(finalLine)&&finalLine===0)return true;
    var allocations=Array.isArray(item.line_level_discount_allocations)?item.line_level_discount_allocations:[];
    var discounted=allocations.reduce(function(sum,x){return sum+Number(x&&x.amount||0)},0);
    return original>0&&discounted>=original;
  }

  function matchesPlan(cart,plan){
    var gifts=(cart&&Array.isArray(cart.items)?cart.items:[]).filter(isGift);
    var ids=Object.keys(plan||{});
    if(!ids.length)return false;
    var ok=ids.every(function(id){
      var lines=gifts.filter(function(x){return String(x.variant_id||x.id||'')===String(id)});
      var qty=lines.reduce(function(sum,x){return sum+(Number(x.quantity)||0)},0);
      return qty===Number(plan[id]||0)&&lines.length>0&&lines.every(isFree);
    });
    if(!ok)return false;
    return gifts.every(function(x){return Object.prototype.hasOwnProperty.call(plan,String(x.variant_id||x.id||''))});
  }

  function giftPlanPresent(cart,plan){
    var gifts=(cart&&Array.isArray(cart.items)?cart.items:[]).filter(isGift);
    var ids=Object.keys(plan||{});
    if(!ids.length)return false;
    var ok=ids.every(function(id){
      var qty=gifts.filter(function(x){return String(x.variant_id||x.id||'')===String(id)})
        .reduce(function(sum,x){return sum+(Number(x.quantity)||0)},0);
      return qty===Number(plan[id]||0);
    });
    if(!ok)return false;
    return gifts.every(function(x){return Object.prototype.hasOwnProperty.call(plan,String(x.variant_id||x.id||''))});
  }

  function statusBox(){
    var input=document.querySelector('[data-mxp3-promo]');
    if(!input)return null;
    var wrap=input.closest('.mxp3promo');if(!wrap)return null;
    var box=document.querySelector('[data-mxp-promo-status]');
    if(!box){
      box=document.createElement('div');
      box.setAttribute('data-mxp-promo-status','');
      box.style.cssText='margin-top:8px;padding:9px 11px;border-radius:10px;font-size:10.5px;font-weight:850;line-height:1.4;display:none';
      wrap.insertAdjacentElement('afterend',box);
    }
    return box;
  }
  function setStatus(msg,ok){
    var box=statusBox();if(!box)return;
    if(!msg){box.style.display='none';box.textContent='';return}
    box.style.display='block';
    box.style.background=ok?'#eefbf1':'#fff0ed';
    box.style.border='1px solid '+(ok?'#b9e8c2':'#ffc6b8');
    box.style.color=ok?'#176b2c':'#a33116';
    box.textContent=msg;
  }
  function setBusy(on,label){
    var b=document.querySelector('[data-mxp3-apply]'),i=document.querySelector('[data-mxp3-promo]');
    if(b){b.disabled=!!on;b.textContent=on?(label||'Patientez…'):'Appliquer'}
    if(i)i.disabled=!!on;
  }
  function saveFlash(msg,ok){
    try{sessionStorage.setItem(FLASH,JSON.stringify({msg:msg,ok:!!ok}))}catch(e){}
  }
  function showFlash(){
    try{
      var raw=sessionStorage.getItem(FLASH);if(!raw)return;
      sessionStorage.removeItem(FLASH);
      var x=JSON.parse(raw);if(x&&x.msg)setStatus(x.msg,!!x.ok);
    }catch(e){}
  }

  function giftSpec(item){
    var id=Number(item&&item.variant_id||item&&item.id||0);
    var map={};

    map[V.charger2a]={
      title:'Prise secteur USB-A 2A',
      rows:[
        {label:'Type',value:'Prise secteur'},
        {label:'Sortie',value:'USB-A · 2A'},
        {label:'Contenu',value:'1 prise secteur'}
      ]
    };
    map[V.lightning]={
      title:'Câble USB-A → Lightning',
      rows:[
        {label:'Connectique',value:'USB-A → Lightning'},
        {label:'Compatibilité',value:'iPhone et iPad avec port Lightning'},
        {label:'Contenu',value:'1 câble'}
      ]
    };
    map[V.usbAC]={
      title:'Câble USB-A → USB-C',
      rows:[
        {label:'Connectique',value:'USB-A → USB-C'},
        {label:'Compatibilité',value:'Smartphones et tablettes USB-C'},
        {label:'Contenu',value:'1 câble'}
      ]
    };
    map[V.macL]={
      title:'Chargeur MacBook MagSafe L',
      rows:[
        {label:'Connectique',value:'MagSafe L'},
        {label:'Compatibilité',value:'Anciens MacBook compatibles MagSafe L'},
        {label:'Contenu',value:'1 chargeur'}
      ]
    };
    map[V.macT]={
      title:'Chargeur MacBook MagSafe T',
      rows:[
        {label:'Connectique',value:'MagSafe T'},
        {label:'Compatibilité',value:'MacBook compatibles MagSafe T'},
        {label:'Contenu',value:'1 chargeur'}
      ]
    };
    map[V.macUsbC]={
      title:'Chargeur MacBook USB-C',
      rows:[
        {label:'Connectique',value:'USB-C'},
        {label:'Compatibilité',value:'MacBook USB-C et Apple Silicon'},
        {label:'Contenu',value:'1 chargeur'}
      ]
    };
    map[V.pin30]={
      title:'Chargeur 30 broches',
      rows:[
        {label:'Connectique',value:'Apple 30 broches'},
        {label:'Compatibilité',value:'Anciens iPhone et iPad compatibles'},
        {label:'Contenu',value:'1 chargeur'}
      ]
    };
    map[V.microUsb]={
      title:'Chargeur Micro-USB',
      rows:[
        {label:'Connectique',value:'Micro-USB'},
        {label:'Compatibilité',value:'Anciens Samsung et Android compatibles'},
        {label:'Contenu',value:'1 chargeur'}
      ]
    };

    return map[id]||{
      title:String(item&&item.product_title||'Accessoire'),
      rows:[{label:'Type',value:'Accessoire compatible'}]
    };
  }

  function formatGiftMoney(cents){
    try{
      return new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR',minimumFractionDigits:0,maximumFractionDigits:2}).format((Number(cents)||0)/100);
    }catch(e){
      return ((Number(cents)||0)/100).toFixed(2).replace('.',',')+' €';
    }
  }

  function giftOriginalCents(item){
    var qty=Math.max(1,Number(item&&item.quantity)||1);
    var unit=Number(item&&item.original_price||item&&item.price||0);
    var line=Number(item&&item.original_line_price||0);
    return line>0?line:(unit>0?unit*qty:0);
  }

  function promoPriceHtml(item){
    var original=giftOriginalCents(item);
    var crossed=original>0?'<del style="color:#8a9098;font-size:.82em;font-weight:700;margin-right:7px">'+formatGiftMoney(original)+'</del>':'';
    return crossed+'<strong style="color:#111216;font-size:1em;font-weight:950">0 €</strong>';
  }

  function promoNote(code){
    var note=document.createElement('div');
    note.setAttribute('data-mxp-gift-note','1');
    note.className='mxp-promo-gift-note';
    note.style.cssText='display:inline-flex;align-items:center;gap:7px;width:max-content;max-width:100%;margin-top:8px;padding:7px 10px;border-radius:8px;background:#eaf9ee;color:#13a047;font-size:10px;font-weight:800;line-height:1.25';
    note.appendChild(document.createTextNode('🎁 Offert grâce au code promo '));
    var strong=document.createElement('strong');
    strong.textContent=String(code||'').toUpperCase();
    strong.style.fontWeight='950';
    note.appendChild(strong);
    return note;
  }

  function buildMainSpecs(spec){
    var box=document.createElement('div');
    box.className='mxp3attrs';
    box.setAttribute('data-mxp-gift-specs','1');
    spec.rows.forEach(function(row){
      var wrap=document.createElement('div');
      wrap.className='mxp3attr';
      var label=document.createElement('span');
      label.textContent=row.label;
      var value=document.createElement('strong');
      value.textContent=row.value;
      wrap.appendChild(label);wrap.appendChild(value);box.appendChild(wrap);
    });
    return box;
  }

  function buildDrawerSpecs(spec){
    var box=document.createElement('div');
    box.className='mxp-drawer-meta';
    box.setAttribute('data-mxp-gift-specs','1');
    spec.rows.forEach(function(row){
      var wrap=document.createElement('div');
      wrap.className='mxp-drawer-meta-row';
      var b=document.createElement('b');b.textContent=row.label+' :';
      var span=document.createElement('span');span.textContent=row.value;
      wrap.appendChild(b);wrap.appendChild(span);box.appendChild(wrap);
    });
    return box;
  }

  function findDrawerLine(key){
    var lines=document.querySelectorAll('#CartDrawer [data-mxp-line]');
    for(var i=0;i<lines.length;i++){
      if(String(lines[i].getAttribute('data-key')||'')===String(key||''))return lines[i];
    }
    return null;
  }

  function decorate(cart,code){
    var gifts=(cart&&Array.isArray(cart.items)?cart.items:[]).filter(isGift);

    gifts.forEach(function(item){
      var key=String(item.key||''),spec=giftSpec(item);

      var seenMain=false;
      Array.prototype.slice.call(document.querySelectorAll('[data-qty-change]')).forEach(function(btn){
        if(String(btn.getAttribute('data-qty-change')||'')!==key)return;
        var line=btn.closest('.mxp3line');
        if(!line||seenMain)return;
        seenMain=true;
        line.setAttribute('data-mxp-promo-gift','1');

        var name=line.querySelector('.mxp3name');
        if(name)name.textContent=spec.title;

        var content=line.children&&line.children[1]?line.children[1]:line;
        var oldAttrs=line.querySelector('.mxp3attrs');
        if(oldAttrs&&!oldAttrs.hasAttribute('data-mxp-gift-specs'))oldAttrs.remove();
        if(content&&!line.querySelector('[data-mxp-gift-specs]')){
          var top=line.querySelector('.mxp3topline');
          if(top)top.insertAdjacentElement('afterend',buildMainSpecs(spec));
        }
        if(content&&!line.querySelector('[data-mxp-gift-note]'))content.appendChild(promoNote(code));

        var price=line.querySelector('.mxp3price');
        if(price)price.innerHTML=promoPriceHtml(item);

        var actions=line.querySelector('.mxp3actions');
        if(actions)actions.innerHTML='<span style="display:inline-flex;align-items:center;min-height:30px;padding:0 10px;border:1px solid #e3e6e9;border-radius:9px;background:#fafafa;color:#555d66;font-size:9px;font-weight:800">Quantité '+String(Number(item.quantity)||1)+' · offerte</span>';
      });

      var drawerLine=findDrawerLine(key);
      if(drawerLine){
        drawerLine.setAttribute('data-mxp-promo-gift','1');

        var drawerName=drawerLine.querySelector('.mxp-drawer-title');
        if(drawerName)drawerName.textContent=spec.title;

        var drawerContent=drawerLine.querySelector('.mxp-drawer-content')||drawerLine;
        var drawerMeta=drawerLine.querySelector('.mxp-drawer-meta');
        if(drawerMeta&&!drawerMeta.hasAttribute('data-mxp-gift-specs'))drawerMeta.remove();
        if(drawerContent&&!drawerLine.querySelector('[data-mxp-gift-specs]')){
          var topRow=drawerLine.querySelector('.mxp-drawer-top');
          if(topRow)topRow.insertAdjacentElement('afterend',buildDrawerSpecs(spec));
        }

        var main=drawerLine.querySelector('.mxp-drawer-main');
        if(main&&!drawerLine.querySelector('[data-mxp-gift-note]'))main.appendChild(promoNote(code));

        var drawerPrice=drawerLine.querySelector('.mxp-drawer-price');
        if(drawerPrice)drawerPrice.innerHTML=promoPriceHtml(item);

        var drawerActions=drawerLine.querySelector('.mxp-drawer-actions');
        if(drawerActions)drawerActions.innerHTML='<span style="display:inline-flex;align-items:center;min-height:28px;padding:0 9px;border:1px solid #e3e6e9;border-radius:9px;background:#fafafa;color:#555d66;font-size:9px;font-weight:800">Quantité '+String(Number(item.quantity)||1)+' · offerte</span>';
      }
    });

    var input=document.querySelector('[data-mxp3-promo]');
    if(input&&code)input.value=code;
  }

  function currentUrl(){try{return new URL(window.location.href)}catch(e){return null}}
  function previewParams(target){
    var u=currentUrl();if(!u)return target;
    ['preview_theme_id','preview_key','pb'].forEach(function(k){
      if(u.searchParams.has(k))target.searchParams.set(k,u.searchParams.get(k));
    });
    return target;
  }
  function discountUrl(code){
    var target=previewParams(new URL(base()+'cart',window.location.origin));
    return base()+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(target.pathname+target.search);
  }
  function cleanCartUrl(){
    var target=previewParams(new URL(base()+'cart',window.location.origin));
    return target.pathname+target.search;
  }
  function clearTxn(){try{sessionStorage.removeItem(TXN)}catch(e){}}
  function clearConfirmed(){try{sessionStorage.removeItem(CONF)}catch(e){}}
  function clearAll(){clearTxn();clearConfirmed()}

  function apply(code){
    code=String(code||'').trim();
    if(!code){setStatus('Saisissez un code promo.',false);return}

    if(!isValidGiftCode(code)){
      clearAll();
      setBusy(true,'Application…');
      window.location.assign(discountUrl(code));
      return;
    }

    setBusy(true,'Préparation…');
    setStatus('Ajout des accessoires correspondant à votre appareil…',true);

    fetchCart().then(function(cart){
      clearConfirmed();
      if((cart.items||[]).some(isGift))return removeGifts(cart).then(fetchCart);
      return cart;
    }).then(function(cart){
      var plan=planFor(cart);
      if(!Object.keys(plan).length){
        clearTxn();
        window.location.assign(discountUrl(code));
        return new Promise(function(){});
      }

      try{
        sessionStorage.setItem(TXN,JSON.stringify({
          code:code,
          plan:plan,
          ts:Date.now(),
          stage:'primary'
        }));
      }catch(e){}

      return addPlan(plan,code).then(function(){
        window.location.assign(discountUrl(code));
        return new Promise(function(){});
      });
    }).catch(function(){
      clearAll();
      fetchCart().then(removeGifts).catch(function(){});
      setBusy(false);
      setStatus('Impossible d’ajouter les accessoires. Le panier principal reste intact.',false);
    });
  }

  function confirmGiftCart(cart,code,plan){
    clearTxn();
    try{
      sessionStorage.setItem(CONF,JSON.stringify({
        code:code,
        plan:plan,
        ts:Date.now()
      }));
    }catch(e){}
    decorate(cart,code);
    setBusy(false);
    var count=(cart.items||[]).filter(isGift).reduce(function(sum,x){return sum+(Number(x.quantity)||0)},0);
    setStatus('Code '+code+' appliqué · '+count+' accessoire'+(count>1?'s':'')+' offert'+(count>1?'s':'')+' ajouté'+(count>1?'s':'')+' au panier.',true);
  }

  function verifyTransaction(txn){
    setBusy(true,'Vérification…');
    var input=document.querySelector('[data-mxp3-promo]');
    if(input)input.value=txn.code||'';

    fetchCart().then(function(cart){
      var currentPlan=planFor(cart);

      if(!samePlan(currentPlan,txn.plan)){
        clearAll();
        setBusy(false);
        setStatus('Le panier a changé pendant l’application du code. Réappliquez le code promo.',false);
        return null;
      }

      if(!giftPlanPresent(cart,txn.plan)){
        clearAll();
        setBusy(false);
        setStatus('Les accessoires offerts n’ont pas été ajoutés correctement. Réappliquez le code promo.',false);
        return null;
      }

      if(txn.stage==='primary'&&planNeedsSingleGift(txn.plan)){
        txn.stage='single';
        persistTxn(txn);
        window.location.assign(discountUrl(SINGLE_GIFT_CODE));
        return new Promise(function(){});
      }

      if(matchesPlan(cart,txn.plan)){
        confirmGiftCart(cart,txn.code,txn.plan);
        return null;
      }

      clearAll();
      setBusy(false);
      setStatus('Le code promo est reconnu mais tous les accessoires ne sont pas encore gratuits. Réappliquez le code promo.',false);
      return null;
    }).catch(function(){
      clearAll();
      setBusy(false);
      setStatus('Impossible de vérifier les accessoires. Réessayez sans modifier le panier.',false);
    });
  }

  function verifyConfirmed(conf){
    if(!conf||!conf.code||!conf.plan)return;
    if(conf.ts&&Date.now()-Number(conf.ts)>MAX_AGE){clearConfirmed();return}

    fetchCart().then(function(cart){
      var currentPlan=planFor(cart);
      if(samePlan(currentPlan,conf.plan)&&matchesPlan(cart,conf.plan)){
        decorate(cart,conf.code);
        var count=(cart.items||[]).filter(isGift).reduce(function(sum,x){return sum+(Number(x.quantity)||0)},0);
        setStatus('Code '+conf.code+' appliqué · '+count+' accessoire'+(count>1?'s':'')+' offert'+(count>1?'s':'')+'.',true);
        return;
      }

      if(!samePlan(currentPlan,conf.plan)){
        return reconcilePromoGifts(cart).then(function(nextCart){
          var nextPlan=planFor(nextCart);
          if(Object.keys(nextPlan).length&&matchesPlan(nextCart,nextPlan)){
            try{
              sessionStorage.setItem(CONF,JSON.stringify({
                code:conf.code,
                plan:nextPlan,
                ts:Date.now()
              }));
            }catch(e){}
            decorate(nextCart,conf.code);
          }else if(!Object.keys(nextPlan).length){
            clearConfirmed();
          }else{
            clearConfirmed();
          }

          if(document.body.classList.contains('template-cart')){
            window.location.reload();
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:updated',{
            detail:{cart:nextCart,mxpPromoReconciled:true}
          }));
        });
      }

      clearConfirmed();
      setStatus('La remise cadeau doit être réappliquée pour remettre tous les accessoires à 0 €.',false);
    }).catch(function(){});
  }

  function init(){
    showFlash();

    var txn=null,conf=null;
    try{txn=JSON.parse(sessionStorage.getItem(TXN)||'null')}catch(e){}
    if(txn&&txn.ts&&Date.now()-Number(txn.ts)>MAX_AGE){clearTxn();txn=null}

    if(txn&&txn.code&&txn.plan&&(txn.stage==='primary'||txn.stage==='single')){
      verifyTransaction(txn);
      return;
    }

    try{conf=JSON.parse(sessionStorage.getItem(CONF)||'null')}catch(e){}
    if(conf&&conf.code&&conf.plan)verifyConfirmed(conf);
  }

  document.addEventListener('keydown',function(e){
    var input=e.target&&e.target.matches&&e.target.matches('[data-mxp3-promo]')?e.target:null;
    if(!input||e.key!=='Enter')return;
    e.preventDefault();
    e.stopImmediatePropagation();
    apply(input.value);
  },true);

  window.MXPPromoGift={apply:apply,reconcile:reconcilePromoGifts};

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();